import {useCallback, useState, useReducer} from "react";
import api from "../../../../../../api/quiz";

function reducer(state, action) {
  switch (action.type) {
    case "QUESTION_VARIANT_LIST":
      return {
        ...state,
        variants: action.variants
      };
    default:
      return {
        ...state,
        ...action.payload
      };
  }
}

const intialState = {
  variants: []
};

export default function useQuestionDetails() {
  const [dataSources, dispatch] = useReducer(reducer, intialState);

  const [createdVariant, setCreatedVariant] = useState(null);
  const [updatedVariant, setUpdatedVariant] = useState(null);
  const [updatedScale, setUpdatedScale] = useState(null);
  const [isCreatingVariant, setIsCreatingVariant] = useState(false);
  const [isDeletingVariant, setIsDeletingVariant] = useState(false);
  const [isUpdatingVariant, setIsUpdatingVariant] = useState(false);

  function getVariantList(questionId) {
    api.getQuestionVariantList(questionId).then(({ data }) => {
      dispatch({ type: "QUESTION_VARIANT_LIST", variants: data });
    }).catch((err) => {
      console.log(err);
    });
  }

  const createVariant = useCallback((id,data) => {
    setIsCreatingVariant(true);
    return api.createQuestionVariant(id,data).then((resp) => {
      setCreatedVariant(resp.data);
      setIsCreatingVariant(false);
    }, (reason) => {
      setCreatedVariant({success: false, errors: [{reason}]});
      setIsCreatingVariant(false);
    });
  }, [setIsCreatingVariant]);

  const updateVariant = useCallback((id,data) => {
    setIsUpdatingVariant(true);
    return api.createQuestionVariant(id,data).then((resp) => {
      setUpdatedVariant(resp.data);
      setIsUpdatingVariant(false);
    }, (reason) => {
      setUpdatedVariant({success: false, errors: [{reason}]});
      setIsUpdatingVariant(false);
    });
  }, [setIsUpdatingVariant]);

  const deleteVariant = useCallback((id) => {
    setIsDeletingVariant(true);
    return api.deleteQuestionVariant(id).then(() => {
      setIsDeletingVariant(false);
    }, (reason) => {
      console.log(reason);
      setIsDeletingVariant(false);
    });
  }, [setIsDeletingVariant]);

  const updateQuestionScale = useCallback((id,data) => {
    setIsCreatingVariant(true);
    return api.updateQuestionScale(id,data).then((resp) => {
      setUpdatedScale(resp.data);
    }, (reason) => {
      setUpdatedScale({success: false, errors: [{reason}]});
    });
  }, [setIsCreatingVariant]);

  return {
    getVariantList,
    dataSources,
    deleteVariant,
    createVariant,
    isCreatingVariant,
    isDeletingVariant,
    createdVariant,
    setCreatedVariant,
    updateQuestionScale,
    updatedScale,
    setUpdatedScale,
    updateVariant,
    updatedVariant,
    isUpdatingVariant
  };
}
